/**
 * SHRINE BIOMES - One-time use tiles that grant permanent bonuses
 *
 * 7 shrine types:
 * - 4 stat shrines: +5 STR/DEX/INT/LUK permanently
 * - Vitality shrine: +50 max HP permanently
 * - Experience shrine: Grant XP based on player level
 * - Blessing shrine: Random permanent buff (very rare)
 *
 * Spawn rate: ~1 per 25-30 tiles (via pity timer)
 * Activation: Click button when standing on shrine
 */

export const SHRINE_BIOMES = {
  shrineOfStrength: {
    id: 'shrineOfStrength',
    name: 'Shrine of Strength',
    icon: '⚔️',
    description: 'An ancient altar radiating raw power. Warriors have prayed here for generations.',
    color: '#c41e3a',
    minAge: 1,
    spawnWeight: 10,
    isShrineBiome: true,
    shrineType: 'strength',
    shrineEffect: { type: 'stat', stat: 'STR', value: 5 },
    entryEvents: [
      { id: 'power', weight: 100, text: 'You feel ancient power emanating from the shrine...' },
    ],
    canBuildOutpost: false,
    gatherableResources: null,
  },

  shrineOfAgility: {
    id: 'shrineOfAgility',
    name: 'Shrine of Agility',
    icon: '🏃',
    description: 'A weathered monument to swift hunters of old.',
    color: '#2e8b57',
    minAge: 1,
    spawnWeight: 10,
    isShrineBiome: true,
    shrineType: 'agility',
    shrineEffect: { type: 'stat', stat: 'DEX', value: 5 },
    entryEvents: [
      { id: 'swift', weight: 100, text: 'The air itself seems lighter here...' },
    ],
    canBuildOutpost: false,
    gatherableResources: null,
  },

  shrineOfWisdom: {
    id: 'shrineOfWisdom',
    name: 'Shrine of Wisdom',
    icon: '📚',
    description: 'Scholars once gathered here seeking enlightenment.',
    color: '#4169e1',
    minAge: 1,
    spawnWeight: 10,
    isShrineBiome: true,
    shrineType: 'wisdom',
    shrineEffect: { type: 'stat', stat: 'INT', value: 5 },
    entryEvents: [
      { id: 'knowledge', weight: 100, text: 'Ancient whispers fill your mind with forgotten lore...' },
    ],
    canBuildOutpost: false,
    gatherableResources: null,
  },

  shrineOfFortune: {
    id: 'shrineOfFortune',
    name: 'Shrine of Fortune',
    icon: '🍀',
    description: 'A lucky charm blessed by fate itself.',
    color: '#ffd700',
    minAge: 1,
    spawnWeight: 10,
    isShrineBiome: true,
    shrineType: 'fortune',
    shrineEffect: { type: 'stat', stat: 'LUK', value: 5 },
    entryEvents: [
      { id: 'luck', weight: 100, text: 'Four-leaf clovers bloom around the ancient stones...' },
    ],
    canBuildOutpost: false,
    gatherableResources: null,
  },

  shrineOfVitality: {
    id: 'shrineOfVitality',
    name: 'Shrine of Vitality',
    icon: '❤️',
    description: 'Life energy pulses through this sacred ground.',
    color: '#dc143c',
    minAge: 1,
    spawnWeight: 15,
    isShrineBiome: true,
    shrineType: 'vitality',
    shrineEffect: { type: 'health', value: 50 },
    entryEvents: [
      { id: 'life', weight: 100, text: 'Warmth spreads through your body...' },
    ],
    canBuildOutpost: false,
    gatherableResources: null,
  },

  shrineOfExperience: {
    id: 'shrineOfExperience',
    name: 'Shrine of Experience',
    icon: '✨',
    description: 'Heroes of legend left their memories here.',
    color: '#9370db',
    minAge: 1,
    spawnWeight: 20,
    isShrineBiome: true,
    shrineType: 'experience',
    shrineEffect: { type: 'xp', multiplier: 50 }, // 50 × player level
    entryEvents: [
      { id: 'memories', weight: 100, text: 'Visions of legendary battles flash before your eyes...' },
    ],
    canBuildOutpost: false,
    gatherableResources: null,
  },

  shrineOfBlessing: {
    id: 'shrineOfBlessing',
    name: 'Shrine of Blessing',
    icon: '🙏',
    description: 'The gods themselves smile upon this place.',
    color: '#f0e68c',
    minAge: 2,
    spawnWeight: 5,
    isShrineBiome: true,
    shrineType: 'blessing',
    shrineEffect: { type: 'random_blessing' }, // Random permanent buff
    entryEvents: [
      { id: 'divine', weight: 100, text: 'Divine light illuminates the ancient altar...' },
    ],
    canBuildOutpost: false,
    gatherableResources: null,
  },
};

export default SHRINE_BIOMES;
